import type { FieldMiddleware } from '@nestjs/graphql'

/**
 * The slice of the API's GraphQL context this reads - see `ownerOrStaffOnly` for where it comes from.
 */
interface StaffOnlyContext {
  req?: {
    user?: {
      isAdmin?: boolean
    }
  }
}

/**
 * Field middleware for a value only staff may read, such as the Recommended score breakdown, which carries a
 * campaign's claim and impression counts. Everyone else, signed in or not, gets null for the field whichever
 * query reached the record and whatever the service filled in [sc-28740].
 *
 * Returning without calling `next` is what keeps the stored value from ever being read.
 */
export const staffOnly: FieldMiddleware<unknown, StaffOnlyContext> = ({ context }, next) => {
  return context?.req?.user?.isAdmin === true ? next() : null
}
